import { serializeLexical } from './serialize';

const RichText = ({ content }) => {
  if (!content) {
    return null;
  }

  return (
    content &&
    !Array.isArray(content) &&
    typeof content === 'object' &&
    'root' in content &&
    serializeLexical({ nodes: content?.root?.children })
  );
};

export { RichText };
